import { ClientRecord } from "../../ClientsGrid.utils";

export interface ApprovalStatusRendererProps {
  rowData: ClientRecord;
}

export interface ApproverData {
  UserName: string;
  UserFullName: string;
  UserRole: string;
  ApprovalStatus: string;
  Message: string;
  UpdatedDate: string;
}

/**
 * Calculates the popup position relative to the trigger button.
 *
 * @param buttonRef - Ref to the button element triggering the popup.
 * @param setPopupPosition - Callback to set the position of the popup on screen.
 */
export const updatePopupPosition = (
  buttonRef: { current: { getBoundingClientRect: () => any } | null },
  setPopupPosition: (arg: { top: number; left: number }) => void
) => {
  if (buttonRef.current) {
    const rect = buttonRef.current.getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom + window.scrollY - 5,
      left: rect.left + window.scrollX - 575,
    });
  }
};
